import { render } from "./WaveData.vue?vue&type=template&id=73730c94"
import script from "./WaveData.vue?vue&type=script&lang=js"
export * from "./WaveData.vue?vue&type=script&lang=js"

import "./WaveData.vue?vue&type=style&index=0&id=73730c94&lang=css"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__